import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';
import { UtilityService } from '../utility/utility.service';

@Injectable({
  providedIn: 'root'
})
export class UserRightService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
    private utitlity: UtilityService
  ) {
    if (this.session.GetUserDetails() != null) {
      environment.API_URL = this.session.GetUserDetails().ApiUrl;
    }
  }

  ESS_ProfileMenuRightsView(Detail: any): Observable<any> {
    return this.utitlity.callWithRetry('ESS_ProfileMenuRights/View', Detail);
    // return this.http.post<any>(environment.API_URL + `ESS_ProfileMenuRights/View`,
    //   this.session.SetClass(Detail)
    // ).pipe(map(response => {
    //   if (response.Error_Code == '11' || response.Error_Code == '02') {
    //     this.session.End();
    //   } else {
    //     return response;
    //   }
    // }));
  }

  ESS_ProfileMenuRights_SelectSelect(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ProfileMenuRights_Select/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_ProfileMenuRightsInsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ProfileMenuRightsInsert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_GetUserRole(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_GetUser/Role`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

}
